import { request } from "../utils/request"

/**
 * 获取项目下的所有测点数据
 * 兼容项目用户，可不带 projId 参数
 * @param params 
 * @returns 
 */
export const getPoints = (params?: { cmpId?: number, projId?: number }) => {
    return request.get('/point', { params })
}

/**
 * fetch point detail
 * @param params 
 * @returns 
 */
export const getPointDetail = (id: number) => {
    return request.get('/point/detail/' + id)
}

/**
 * update point config
 * @param data 
 * @returns 
 */
export const updatePointConfig = (data: { id: number, warning: object, unit: string, label: object }) => {
    return request.post('/point/update/config', data)
}